import { render } from "./TeamHubRoleCol.vue?vue&type=template&id=5aed7f8f&ts=true"
import script from "./TeamHubRoleCol.vue?vue&type=script&lang=ts"
export * from "./TeamHubRoleCol.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__